export const MANDATORY_FEATURE_CATEGORIES = [
  "vehicle",
  "stop",
  "route",
  "admin",
  "settings",
];

export const BASE_FEATURE_CATEGORIES = [
  "vehicle",
  "stop",
  "route",
  "schedule",
  "site",
  "driver",
  "tracking247",
  "alerts",
  "manageData",
  
];

export const SCHOOL_FEATURE_CATEGORIES = ["student", "attendant"];

export const FEATURE_CATEGORIES_WITHOUT_FEATURES = [
  "site",
  "driver",
  "tracking247",
  "alerts",
  "student",
  "attendant",
  "manageData",
];

export const normalizeApiPath = (apiPath = "") => {
  const trimmedPath = apiPath.trim();

  if (!trimmedPath) {
    return "";
  }

  return trimmedPath.startsWith("/") ? trimmedPath : `/${trimmedPath}`;
};

export const getPredefinedFeatureCategories = ({
  includeSchoolCategories = false,
} = {}) =>
  includeSchoolCategories
    ? [...BASE_FEATURE_CATEGORIES, ...SCHOOL_FEATURE_CATEGORIES]
    : BASE_FEATURE_CATEGORIES;

export const getFeatureCategory = (feature) => {
  const normalizedPath = normalizeApiPath(feature?.api_path);
  const pathParts = normalizedPath.split("/");
  const basePath = pathParts[2];
  const subPath = pathParts[3];

  if (!basePath) {
    return null;
  }

  if (basePath === "managedata") return "manageData";
  if (basePath === "employee") return "attendant";
  if (basePath === "alert") return "alerts";
  if (basePath === "vehicle" && subPath === "alert") return "alerts";
  if (basePath === "user" || basePath === "role") return "admin";
  if (basePath === "settings" || basePath === "label") return "settings";

  return basePath;
};

export const getFeaturesForCategory = (features, category) =>
  features.filter((feature) => getFeatureCategory(feature) === category);

export const getOrderedFeatureCategories = (
  features,
  {
    includeSchoolCategories = false,
    alwaysVisibleCategories = FEATURE_CATEGORIES_WITHOUT_FEATURES,
  } = {},
) => {
  const predefinedCategories = getPredefinedFeatureCategories({
    includeSchoolCategories,
  });

  const apiCategories = Array.from(
    new Set(features.map((feature) => getFeatureCategory(feature)).filter(Boolean)),
  ).filter(
    (category) =>
      predefinedCategories.includes(category) || category === "admin",
  );

  return [
    ...predefinedCategories.filter(
      (category) =>
        apiCategories.includes(category) ||
        alwaysVisibleCategories.includes(category),
    ),
    "admin",
  ];
};

export const getFeatureCategoryDisplayName = (category) => {
  if (category === "tracking247") return "24/7 Tracking";
  if (category === "alerts") return "Alerts & Notifications";
  if (category === "admin") return "Admin Panel";
  if (category === "manageData") return "Manage Data";
  if (category === "settings") return "Settings";
  if (category === "student") return "Student Management";
  if (category === "attendant") return "Attendant Management";

  return category.charAt(0).toUpperCase() + category.slice(1) + " Management";
};

export const normalizeOrganizationTypes = (organizationType) => {
  if (!organizationType) {
    return [];
  }

  const rawTypes = Array.isArray(organizationType)
    ? organizationType
    : [organizationType];

  return rawTypes
    .flatMap((type) =>
      typeof type === "string" ? type.split(",") : [type],
    )
    .map((type) => (typeof type === "string" ? type.trim() : type))
    .filter(Boolean);
};

export const includesSchoolTracking = (...organizationTypeSources) =>
  organizationTypeSources.some((organizationType) =>
    normalizeOrganizationTypes(organizationType).includes("schoolTrack"),
  );
